import React, { useState } from 'react';

const BabyNameModal = ({ isOpen, userProfile, onSave, onSkip, onClose }) => {
  const [babyName, setBabyName] = useState('');
  const [saving, setSaving] = useState(false);

  if (!isOpen || !userProfile) return null;

  const getAgeText = (profile) => {
    if (profile?.babyBirthDate) {
      const birth = new Date(profile.babyBirthDate);
      if (!Number.isNaN(birth.getTime())) {
        const now = new Date();
        const months = (now.getFullYear() - birth.getFullYear()) * 12 + (now.getMonth() - birth.getMonth());
        const days = Math.floor((now - birth) / (1000 * 60 * 60 * 24));
        const remainingDays = days - Math.floor(days / 30) * 30;
        return `${Math.max(0, months)} aylık (${Math.max(0, remainingDays)} gün)`;
      }
    }
    switch (profile?.babyAgeGroup) {
      case '6-8': return '6-8 aylık';
      case '8-12': return '8-12 aylık';
      case '12-24': return '12-24 aylık';
      case '2+': return '2+ yaşındaki';
      default: return '';
    }
  };

  const handleSave = async () => {
    if (!babyName.trim()) return;
    
    setSaving(true);
    const success = await onSave(babyName.trim());
    setSaving(false);
    
    if (success) {
      setBabyName('');
    }
  };

  const handleSkip = async () => {
    await onSkip();
    setBabyName('');
  };

  const ageText = getAgeText(userProfile);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-gray-800 rounded-2xl max-w-md w-full p-6 shadow-2xl transform transition-all">
        {/* Magical Header */}
        <div className="text-center mb-6">
          <div className="text-4xl mb-3">✨👶✨</div>
          <h2 className="text-xl font-bold text-gray-800 dark:text-white mb-2">
            Küçük Şefin İsmini Öğrenebilir miyiz?
          </h2>
          <p className="text-gray-600 dark:text-gray-300 text-sm leading-relaxed">
            {ageText} bebeğiniz için tarifleri ona özel hazırlamak istiyoruz. 
            İsmini öğrenirsek tariflerimizi daha kişisel hale getirebiliriz! 💝
          </p>
        </div>

        {/* Baby Name Input */}
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Bebeğinizin İsmi
            </label>
            <input
              type="text"
              value={babyName}
              onChange={(e) => setBabyName(e.target.value)}
              placeholder="Örn: Zeynep, Ali, Ece..."
              className="w-full px-4 py-3 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:border-pink-500 focus:ring-2 focus:ring-pink-200 dark:focus:ring-pink-800 transition-colors"
              maxLength={30}
              autoFocus
            />
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col gap-3 mt-6">
            <button
              onClick={handleSave}
              disabled={!babyName.trim() || saving}
              className="w-full bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 disabled:from-gray-400 disabled:to-gray-400 text-white font-semibold py-3 px-6 rounded-lg transition-all duration-200 shadow-lg hover:shadow-xl disabled:cursor-not-allowed disabled:hover:shadow-lg"
            >
              {saving ? (
                <span className="flex items-center justify-center gap-2">
                  <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
                    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" strokeDasharray="32" strokeDashoffset="32">
                      <animate attributeName="strokeDasharray" dur="2s" values="32;16;32" repeatCount="indefinite"/>
                      <animate attributeName="strokeDashoffset" dur="2s" values="32;0;-32" repeatCount="indefinite"/>
                    </circle>
                  </svg>
                  Kaydediliyor...
                </span>
              ) : (
                <span className="flex items-center justify-center gap-2">
                  <span>💝</span>
                  Kaydet & Tarifleri Kişiselleştir
                </span>
              )}
            </button>

            <button
              onClick={handleSkip}
              className="w-full bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-300 font-medium py-3 px-6 rounded-lg transition-all duration-200"
            >
              Daha Sonra
            </button>
          </div>

          {/* Privacy Note */}
          <div className="mt-4 p-3 bg-blue-50 dark:bg-blue-900/20 rounded-lg border border-blue-200 dark:border-blue-800">
            <p className="text-xs text-blue-700 dark:text-blue-300 text-center">
              🔒 Bu bilgi sadece size özel tarifler hazırlamak için kullanılır ve güvenle saklanır.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BabyNameModal;